module.exports = __webpack_public_path__ + "static/media/view-layer.3bfe489a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/maps/view-layer.svg
// module id = 965
// module chunks = 0